import Save from "./operation-panel-button/save.jsx";
import Submit from "./operation-panel-button/submit.jsx";
import React from "react";
import "./panel.css";
import {connect} from 'react-redux';
// import { closeWindowFunction } from "../../lib/xes/common";
import xesBridge from 'xes-code-base/lib/libs/xes';
import { homeworkStatus, Platform } from "../../lib/xes/xes";
import Modal from "antd/lib/modal";
import bindAll from 'lodash.bindall';
import { getQuery } from "../../lib/xes/xes-lib";
import XesSaverHoc from "../../lib/xes/xes-saver-hoc.jsx";
import Button from 'antd/lib/button';

let cannotEdit = getQuery('cannotEdit') === 'true'
let canBeShare = !(getQuery('canBeShare') === 'false')
let canFullscreen = (getQuery('canFullscreen') === 'true') && !Platform.isPadWebkit()
let hasCloseBtn = Platform.isPadWebkit() || (!cannotEdit && !canFullscreen &&  !Platform.isBrowser())

let cannotEditReason = getQuery('cannotEditReason')

class Homework extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      homeworkStatus: homeworkStatus.PENDING,
      fullScreenBtnLabel: '全屏查看',
      modalVisible: false,
      closeWarning: cannotEdit ? '' : '退出前请保存作品，否则代码可能会丢失哦'
    }
    this.isFullScreen = false
    bindAll(this, [
      'toggleFullScreen',
      'handleCloseModal',
      'handleOpenModal',
      'handleCloseHomework'
    ])    
  }
  componentWillMount() {
  }
  handleCloseModal() {
    this.setState({
      modalVisible: false
    })
  }
  handleOpenModal() {
    if (!this.props.projectWasLoaded) {
      return
    }
    this.setState({
      modalVisible: true
    })
  }
  toggleFullScreen() {
    if (this.isFullScreen) {
      window.parent.exitFullScreen()
      this.setState({
        fullScreenBtnLabel: "全屏查看"
      })
    } else {
      window.parent.enterFullScreen()
      this.setState({
        fullScreenBtnLabel: "退出全屏"
      })
    }
    this.isFullScreen = !this.isFullScreen
  }
  closeHomework() {
    if (!document.referrer) {
      xesBridge.closeWindowFunction()
    } else if (document.referrer.includes('/afterclasstest')) {
      let homepage = window.localStorage.getItem('XESLOCATION') 
      if (homepage) {
        window.location = homepage
      } else {
        xesBridge.closeWindowFunction()
      }
    } else {
      window.history.go(-1)
    }
  }
  handleCloseHomework() {
    if (cannotEdit) {
      this.closeHomework()
    } else {
      this.props.saveProject().then(() => {
        this.closeHomework()
      })
    }
  }
  render() {
    return (
      <div className="panel">
        { !cannotEdit ?
          (
            <div className="btn-group">
              <Save />
              <Submit />
            </div>
          ) : null }
        { hasCloseBtn ?
          (
            <Button className="xes-button" style={{
              color: '#4A82F7',
              borderRadius: '0.25rem',
              outline: 'none',
              border: 'none',
              fontSize: '0.88rem',
              fontWeight: '600'
            }} onClick={this.handleOpenModal}>关闭</Button>
          ) : null }
        { cannotEdit ?
          (
            <div>{ cannotEditReason }</div>
          ) : null }
        {
          canFullscreen ?
            (
              <div className="div-btn-full-screen" onClick={this.toggleFullScreen}>{this.state.fullScreenBtnLabel}</div>
            ) : null
        }
        <Modal
          title="确认退出?"
          cancelText="取消"
          okText="确定"
          visible={this.state.modalVisible}
          onOk={this.handleCloseHomework}
          onCancel={this.handleCloseModal}
        >
          <p>{this.state.closeWarning}</p>
        </Modal>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  projectWasLoaded: state.scratchGui.xesProjectState.isLoaded,
});

const mapDispatchToProps = dispatch => ({
});

export default XesSaverHoc(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Homework)
)
